export default "__VITE_ASSET__CPpX3syJ__"